import Vue from 'vue';
import VueApollo from 'vue-apollo';
import VCalendar from 'v-calendar';
import VueLazyload from 'vue-lazyload';
import VeeValidate from 'vee-validate';
import VTooltip from 'v-tooltip';
import App from '../views/search/App';
import router from '../router/search';
import store from '../store/search';
import VueMatomo from 'vue-matomo';

import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client/core';
import { setContext } from '@apollo/client/link/context';

// Set up the HTTP and auth links
const httpLink = new HttpLink({
  uri: window.location.origin + '/graphql'
});

const authLink = setContext((_, { headers }) => ({
  headers: {
    ...headers,
    'X-Locale': window.appLocale || 'en'
  }
}));

const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache()
});

const apolloProvider = new VueApollo({
  defaultClient: apolloClient
});

Vue.use(VCalendar);
Vue.use(VueApollo);
Vue.use(VueLazyload);
Vue.use(VTooltip);

Vue.use(VeeValidate, {
  classes: true,
  classNames: {
    valid: "is-valid",
    invalid: "is-invalid"
  }
});

Vue.config.productionTip = false;

Vue.filter('categories', function (value) {
  switch(parseInt(value)) {
    case 134:
      return 'Pop Up';
    case 135:
      return 'Event';
    case 136:
      return 'Promotion';
    case 137:
      return 'Advertising';
    case 168:
      return 'Kiosk/Stand';
    default:
      return null;
  }
});

document.addEventListener('DOMContentLoaded', () => {
  if (window.useMatomo) {
    Vue.use(VueMatomo, {
      host: 'https://eleaseloop.matomo.cloud/',
      siteId: 1
    });
    window._paq.push(['trackPageView']);
  }

  const app = new Vue({
    el: '#app',
    router,
    store,
    apolloProvider,
    render: h => h(App),
  });
});
